import { render } from "./DAICreateView.vue?vue&type=template&id=780cb1bc"
import script from "./DAICreateView.vue?vue&type=script&lang=js"
export * from "./DAICreateView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__